<template>
    <div class="top-bar" tabindex="-1">
        <router-link class="logo" to="/home">
            <img class="logo-image" :src="theme === 'dark' ? '/img/logo-hor-blanco.png' : '/img/logo-hor-color.png'" alt="Cibermov" />
        </router-link>

        <NavBar :user="profileName" />

        <div class="top-bar-user-td" v-if="loggedIn">
            <span class="top-bar-hello-message">{{ $t("Hello, $USER!").replace("$USER", renderName(profileName)) }}</span>
            <button type="button" class="top-bar-button-img" :title="$t('User settings')" @click="openUserSettings">
                <img v-if="profileImage" class="btn-image" :src="profileImage" />
                <img v-else class="btn-image" src="@/assets/user.png" />
            </button>
        </div>

        <div class="top-bar-user-td" v-if="!loggedIn">
            <button type="button" class="top-bar-button" :title="$t('Change theme')" @click="invertTheme">
                <i v-if="theme === 'dark'" class="fas fa-sun"></i>
                <i v-else class="fas fa-moon"></i>
            </button>
            <button type="button" @click="login" class="btn btn-primary btn-top-bar-login">
                <i class="fas fa-sign-in"></i> <span>{{ $t("Login") }}</span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { ColorThemeName, getTheme, setTheme } from "@/control/app-preferences";
import { AuthController } from "@/control/auth";
import NavBar from "./NavBar.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: { NavBar },
    name: "TopBar",
    emits: ["toggle-menu", "openModal", "profile-name-changed"],
    data: function () {
        return {
            platformName: import.meta.env.VITE__PLATFORM_NAME || "Cibermov Marketplace",
            loggedIn: AuthController.isAuthenticated(),
            profileImage: AuthController.ProfileImage,
            theme: getTheme(),
            profileName: AuthController.ProfileName || AuthController.Username || "",
        };
    },
    methods: {
        openUserSettings: function () {
            this.$emit("openModal", "account-settings");
        },

        selectLanguage: function () {
            this.$emit("openModal", "change-language-modal");
        },

        invertTheme: function () {
            setTheme(this.theme === "dark" ? "light" : "dark");
        },

        login: function () {
            this.$requireLogin();
        },

        onAuthChanged: function () {
            this.loggedIn = AuthController.isAuthenticated();
            this.profileName = AuthController.ProfileName || AuthController.Username || "";
            this.profileImage = AuthController.ProfileImage;
            this.$emit("profile-name-changed", this.profileName);
        },

        onThemeChanged: function (t: ColorThemeName) {
            this.theme = t;
        },

        renderName: function (name: string): string {
            return ((name + "").split(" ")[0] + "").split(",")[0] || "???";
        },
    },
    mounted: function () {
        this.$listenOnAppEvent("auth-status-changed", this.onAuthChanged.bind(this));
        this.$listenOnAppEvent("theme-changed", this.onThemeChanged.bind(this));
    },
    beforeUnmount: function () {},
});
</script>

<style scoped>
.logo {
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.logo-image {
    width: 180px;
    height: auto;
    object-fit: contain;
}
.logo.router-link-exact-active {
    background-color: transparent;
}

@media (max-width: 768px) {
    .btn-top-bar-login span {
        display: none;
    }
    .btn-top-bar-login i {
        margin-right: 0;
    }
    .logo-image {
        width: 150px;
    }
}
</style>
